/* istanbul ignore file */

// Import the functions you need from the SDKs you need
import { getAuth } from '@firebase/auth'
import { getFirestore, connectFirestoreEmulator } from '@firebase/firestore'
import { getStorage } from '@firebase/storage'
import { initializeApp } from '@firebase/app'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

const firebaseConfig = {
  apiKey: process.env.VITE_FIREBASE_API_KEY,
  authDomain: process.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VITE_FIREBASE_APP_ID,
}

// const firebaseConfig = {
//   apiKey: 'AIzaSyAjMrO1o1Yp9721nlqGXRHiou6sBUc62gI',
//   authDomain: 'otw-production-91ffb.firebaseapp.com',
//   projectId: 'otw-production-91ffb',
//   storageBucket: 'optic-truck-works.appspot.com',
//   messagingSenderId: '250413884321',
//   appId: process.env.VITE_FIREBASE_APP_ID,
// }



// Initialize Firebase
const app = initializeApp(firebaseConfig ? firebaseConfig : {})

const auth = getAuth(app)
/** Optional named Firestore DB for preview builds (`VITE_FIRESTORE_DATABASE=mocks`). Empty / `(default)` → default DB. */
const firestoreDatabaseId = (process.env.VITE_FIRESTORE_DATABASE || '').trim()
const db =
  firestoreDatabaseId && firestoreDatabaseId !== '(default)'
    ? getFirestore(app, firestoreDatabaseId)
    : getFirestore(app)
const isProduction = process.env.VITE_FIREBASE_PROJECT_ID === 'otw-production-91ffb'
const runEmulator = false;
if (!isProduction && runEmulator) {
  connectFirestoreEmulator(db, 'localhost', 5002)
}
const storage = getStorage(app)

export { auth, db, app, firebaseConfig, storage }
